// 網域
global.domain = {
  name: window.location.hostname,
  type: 'master'
}

// 路徑
global.path = '/custom-itinerary';

/**
 * 站台類別
 */
switch(global.domain.name){
  // 本機
  case 'localhost':
    global.domain.type = 'dev';  // 本機
    global.api = '';
    break;
  case 't1.besttour.com.tw':
    global.domain.type = 'dev';
    global.api = 'https://t1.besttour.com.tw/api/';
    break;
  case 'www.besttour.com.tw':  // 直客
  default:
    global.isAgent = false;
    global.domain.type = 'master';
    global.api = 'https://travelapi.besttour.com.tw/api/';
    break;
}